module.exports = __webpack_public_path__ + "media/5.58c3742b.mp3";